import Vue from "vue";
import Vuex from "vuex";

const PermissionManagement = {
  install(Vue, options) {
    Vue.prototype.$can = function(permission) {
      // if(this.$store.state.me.me.role.name === 'Administrator') {
      //   return true;
      // }
      return (
        this.$store.state.me.me.permissions.find(p => p.name === permission) !==
        undefined
      );
    };
    Vue.prototype.$hasRole = function(role) {
      return this.$store.state.me.me.role.name === role;
    };
  }
};

export default PermissionManagement;
